import view from "./view.jsx";

export default view;
